import {Component, OnInit} from '@angular/core';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {AsyncPipe, CommonModule, NgClass, NgForOf, NgIf} from "@angular/common";
import {PageListLinksSection} from "../../../models/Page/Sections/PageListLinksSection";
import {PageCurrentlySection} from "../../../models/Page/Sections/PageCurrentlySection";
import {RouterLink} from "@angular/router";
import {ListPagesSectionComponent} from "../list-pages-section/list-pages-section.component";
import {SelectionSitSectionComponent} from "../selection-sit-section/selection-sit-section.component";
import {PageSelectionSitSection} from "../../../models/Page/Sections/PageSelectionSitSection";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {toggleTrigger} from "../../../trigger/toggle.trigger";

@Component({
  selector: 'currently-section',
  standalone: true,
  imports: [
    BaseSectionComponent,
    NgIf,
    RouterLink,
    ListPagesSectionComponent,
    SelectionSitSectionComponent,
    SynapiListItemsComponent,
    AsyncPipe,
    NgForOf,
    TinyPostComponent,
    TinyPostsFromIdsPipe,
    CommonModule
  ],
  animations: [
    toggleTrigger
  ],
  templateUrl: './currently-section.component.html',
  styleUrl: './currently-section.component.scss'
})
export class CurrentlySectionComponent extends BaseSectionComponent<PageCurrentlySection> implements OnInit{


  season : "winter" | "spring" | "summer" | "autumn" = "winter";
  constructor() {
    super();
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();
    const date = parseInt(currentMonth.toString() + (currentDay<10 ? '0'+currentDay.toString(): currentDay.toString()));

    if((date >= 1221 || date > 0 && date < 320)) this.season = "winter";
    if(date >= 320 && date < 621) this.season = "spring";
    if(date >= 621 && date < 922) this.season = "summer";
    if(date >= 922 && date < 1221) this.season = "autumn";

  }

  override ngOnInit(): void {
    super.ngOnInit();
    if(this.sectionRendered.pages_list?.length>0){
      const index = this.sectionRendered.pages_list.findIndex((pl)=>pl.season == this.season);
      if(index>0){
        this.sectionRendered.pages_list[index].active = true;
      } else {
        this.sectionRendered.pages_list[0].active = true;
      }
    }
  }

  onActiveClick(list:any){
    this.sectionRendered.pages_list.map((p)=>{
      p.active = false;
    });
    list.active=true;
  }
}
